import React, { useState } from "react";
import { Box, TextField, IconButton, Button, InputAdornment, Tooltip, useMediaQuery } from "@mui/material";
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { Motion } from "../../Motion";
import { useDialog } from "../../../Providers/Dialog/DialogProvider";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { useLangNavigate } from "../../../Localization/useLangNavigate";
import { colorRed } from "../../../Resources/Design/theme";
import { Txt, useTrans, useTxt } from "../../../Routes/Localized";
import { APP_TEST_MODE, fontLink, fontText, fontTextHead, greenButton } from "../../../base";
import InfoTooltip from "../../InfoTooltip";
import { isVinValid } from "../../../Shared/base";
import { logAnalytics } from "../../../Firebase/firebase_init";

const VinGreenButton = ({ xxs, buttonText, sxButton = {}, forceText = false }) => {
    return <div>
        <Button
            type="submit"
            variant="contained"
            sx={{
                fontFamily: 'inter',
                m: '8px',
                pb: '4px',
                ml: xxs ? '8px' : '10px',
                minWidth: xxs ? '55px' : '145px',
                height: '55px',
                borderRadius: "50px",
                textTransform: "none",
                fontWeight: 600,
                ...fontLink,
                ...greenButton,
                ...(xxs && { px: '8px' }),
                ...sxButton,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {Boolean(xxs && !forceText) ? (
                <SearchRoundedIcon sx={{ color: 'white', width: '28px', height: '28px' }} />
            ) : (
                buttonText
            )}
        </Button>
    </div>
}

export default function VinButton({ sx = {}, sxInput = {}, sxInputIn = {}, sxButton = {}, value, setValue, onSubmit, onSuccess, buttonTextInit, vinVerify = true, headerView = false, hideEndAdornment = false }) {
    const [vin, setVin] = useState("");
    const { setDialog, setLoading, loading, setDialogError } = useDialog();
    const navigate = useLangNavigate();
    const txt = useTxt();
    const xxs = useMediaQuery("(max-width:600px)");
    const isControlled = Boolean(setValue || value);
    const buttonText = buttonTextInit || <Txt id={"11027"} />;
    const [error, setError] = useState(false);


    const handleSubmit = async () => {
        try {
            const checkValue = isControlled ? value : vin;
            if (vinVerify && !isVinValid(checkValue)) {
                setError(true);
                if (checkValue.length !== 17) {
                    setDialog(txt("9779087"));
                } else {
                    setDialog(txt("9779086"));
                }
                return;
            }
            if (loading) return;

            if (isControlled && onSubmit) {
                onSubmit();
                return;
            }
            if (onSubmit) {
                onSubmit(vin);
                return;
            }

            logAnalytics("vin_input");
            navigate(`cart/vin/${vin.trim()}`);
            if (onSuccess) {
                onSuccess();
            }

        } catch (e) {
            setLoading(false);
            setDialogError();
        }
    }

    return (
        <form
            style={{ width: '100%' }}
            onSubmit={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleSubmit();
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: 'white', border: `2px solid transparent`, borderRadius: '20px', height: '65px', width: '100%',
                    '&:hover': {
                        border: `2px solid #0165F4`
                    },
                    ...(headerView && { flexDirection: 'column' }),
                    ...sx,

                    ...(error && {
                        border: `2px solid ${colorRed}`,
                        '&:hover': {
                            border: `2px solid ${colorRed}`
                        },
                    }),
                }}
            >
                <TextField
                    id="vin"
                    name="vin"
                    autoComplete="on"
                    value={isControlled ? value : vin}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        const value = e.target.value;
                        const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                        if (error) {
                            setError(false);
                        }

                        if (isControlled) {
                            setValue(cleaned);
                        } else {
                            setVin(cleaned);
                        }
                    }}
                    onTouchStart={(e) => e.stopPropagation()}
                    onTouchMove={(e) => e.stopPropagation()}
                    onTouchEnd={(e) => e.stopPropagation()}
                    fullWidth
                    placeholder={txt("main:11024")}
                    variant="standard"
                    inputProps={{ maxLength: 24 }}
                    InputProps={{
                        disableUnderline: true,
                        sx: {
                            '& input': {
                                padding: '5px 0px 4px',
                                ...sxInputIn,
                            },
                            paddingLeft: "30px",
                            py: '18px',
                            ...fontTextHead,
                            ...sxInput,
                        },
                        endAdornment: (
                            <>{hideEndAdornment ? <></> : <InputAdornment position="end" sx={{ ...(headerView && { pr: '12px' }) }}>
                                <InfoTooltip
                                    leaveTouchDelay={12000}
                                    title={<Txt id={"default:888000"} />}
                                    text={<Txt id={"121004"} links={["find_vin"]} color={"#E8E5FF"} />} >
                                    <IconButton size="small" sx={{ color: "#C7C7C7", '&:hover': { color: "#0165F4" } }}>
                                        <HelpRoundedIcon sx={{}} />
                                    </IconButton>
                                </InfoTooltip>
                            </InputAdornment>}
                            </>),
                    }}
                />

                {!headerView && <VinGreenButton xxs={xxs} buttonText={buttonText} sxButton={sxButton} />}

            </Box>
            {headerView && <VinGreenButton xxs={xxs} buttonText={buttonText} sxButton={{
                width: '100%', mx: '0px',
                ...sxButton
            }} forceText={true} />}
        </form>
    );
}
